import hotkeyBindings from './hotkeyBindings';
import windowLevelPresets from './windowLevelPresets';

export default {
  hotkeyBindings,
  windowLevelPresets,
};
